import React from 'react';
import PropTypes from 'prop-types';
import FormPropTypes from 'redux-form/lib/propTypes';
import Link from 'react-router/lib/Link';
import { fullName } from '../../../common/helpers/users';
import SubscriptionDetails from '../../subscriptions/components/SubscriptionDetails';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import AdminSaveButton from '../../shared/Buttons/AdminSaveButton';

const BarberSubscriptions = ({
  submitting,
  handleSubmit,
  barbers,
  barberId,
  subscription,
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <h3 display-if={!barberId}>Barber Subscriptions</h3>
        <SubscriptionDetails
          subscription={subscription}
          display-if={!!barberId && (subscription && subscription.enabled)}
        />
        <p display-if={!!barberId && (!subscription || !subscription.enabled)}>
          <em>There is no subscription for this barber.</em>
        </p>
        <div className="c-separator u-mv--" />
        <div display-if={(!!barberId && subscription && subscription.enabled)}>
          <h3>Cancel Subscription</h3>
          <form onSubmit={handleSubmit}>
            <div className="layout u-mt-">
              <div className="layout__item">
                <CheckboxSwitch
                  name="enabled"
                  label="Enabled"
                  id="enabled"
                />
              </div>
              <div className="layout__item">
                <AdminSaveButton disabled={submitting} content="Save" />
              </div>
            </div>
          </form>
        </div>
        <div display-if={!barberId} className="u-mt-">
          <div>
            {barbers.map(barber => (
              <div key={barber.id}>
                {fullName(barber)} <Link to={`/admin/shops/${barber.shopId}/subscription/${barber.id}`}>Show</Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);

BarberSubscriptions.propTypes = {
  ...FormPropTypes,
  subscription: PropTypes.object,
  barbers: PropTypes.array.isRequired,
  barberId: PropTypes.string,
  subscriptionPlans: PropTypes.arrayOf(PropTypes.object),
};
BarberSubscriptions.defaultProps = {
  subscription: null,
  barbers: [],
  barberId: '',
  subscriptionPlans: [],
};

export default BarberSubscriptions;
